import React, { ReactElement, Dispatch, SetStateAction, useEffect } from 'react';
import styled, { createGlobalStyle } from 'styled-components';

import { Button, Flex, Typography, RichContent } from 'components';

const Wrapper = styled('div')`
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 100;
`;

const Content = styled('div')`
  width: 90%;
  height: 90%;
  background: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 5px;
  overflow: auto;

  ${({ theme }) => theme.fontTypes.type2}

  ${({ theme: { mediaQueries } }) => {
    return `
      padding: 30px;

      ${mediaQueries.desktop} {
        width: 80%;
        height: 80%;
        padding: 60px;
      }
    `;
  }}
`;

const NoScroll = createGlobalStyle`
  body {
    overflow: hidden;
  }
`;

const Centered = styled('div')`
  text-align: center;
`;

export const TermHeadBox = styled.div`
  border: 2px solid ${({ theme }) => theme.colors.gray_300};
  background: ${({ theme }) => theme.colors.gray_100};
  padding: 20px;
`;

export const TermClose = styled.button`
  padding: 0;
  border: 0;
  background: ${({ theme }) => theme.colors.primary_400};
  position: absolute;
  cursor: pointer;

  :hover {
    background: ${({ theme }) => theme.colors.primary_200};
  }

  ${(props: any) => {
    return `
      width: 30px;
      height: 30px;
      border-radius: 15px;
      top: -15px;
      right: -15px;

      ${props.theme.mediaQueries.desktop} {
        width: 50px;
        height: 50px;
        border-radius: 25px;
        top: -25px;
        right: -25px;
      }
    `;
  }}
`;

interface TermProps {
  optin: boolean;
  setOptin: Dispatch<SetStateAction<boolean>>;
  showTerm: boolean;
  setShowTerm: Dispatch<SetStateAction<boolean>>;
}

const Term2 = ({ optin, setOptin, showTerm, setShowTerm }: TermProps): ReactElement => {
  const closeTerm = () => {
    setShowTerm(false);
  };

  useEffect(() => {
    const contentScroll = document.getElementById('contentScroll');

    if (contentScroll) {
      contentScroll.scroll({ top: 0, behavior: 'auto' });
    }

    const keyPressFunc = (e: any) => {
      //   console.log(e.key);
    };

    window.addEventListener('keypress', keyPressFunc);

    return () => {
      window.removeEventListener('keypress', keyPressFunc);
    };
  }, []);

  return (
    <>
      <Wrapper>
        <Content id="contentScroll">
          {/* <TermClose type="button" onClick={() => setShowTerm(!showTerm)}>
          <Typography type="type5" color="white" fontWeight="bold">
            X
          </Typography>
        </TermClose> */}

          <strong>Obrigado pelo interesse em participar da MENTORIA “NA ROTA DO MERCADO FINANCEIRO” oferecida pela MELVER LTDA.</strong>
          <br />
          <br />
          <strong>
            Antes de prosseguir com a contratação, é fundamental que leia atentamente as condições e cláusulas adiante pormenorizados, e compreenda
            todos os termos que regulam a aquisição do programa.
          </strong>
          <br />
          <br />
          <Centered>
            <strong>TERMO DE ADESÃO PARA MENTORIA “NA ROTA DO MERCADO FINANCEIRO”</strong>
          </Centered>
          <br />
          <TermHeadBox>
            <p>
              <strong>CONTRATADA: MELVER LTDA., </strong>pessoa jur&iacute;dica de direito privado, inscrita no cadastro nacional de pessoas
              jur&iacute;dicas sob o n&ordm; 40.919.092/0001-22, inscri&ccedil;&atilde;o municipal n&ordm; 5750750, com sede na Avenida Afonso
              Delambert Neto, n&ordm; 103, sala n&ordm; 04 &ndash; Lagoa da Concei&ccedil;&atilde;o, CEP n&ordm; 88062-000, Florian&oacute;polis,
              Estado de Santa Catarina; <strong>doravante denominada CONTRATADA</strong>.
            </p>
            <br />
            <p>
              <strong>CONTRATANTE: </strong>Aluno(a) que se inscrever, preenchendo corretamente todos os seus dados na ficha de
              inscri&ccedil;&atilde;o deste curso, disponibilizada na plataforma on-line da CONTRATADA;
              <strong> doravante denominado(a) CONTRATANTE</strong>.
            </p>
            <br />
            <p>
              <strong>OBJETO</strong>: Ades&atilde;o aos cursos e materiais did&aacute;ticos para a mentoria &ldquo;Na Rota do Mercado
              Financeiro&rdquo;.
            </p>
            <br />
            <p>
              <strong>PRAZO</strong>: Determinado e vinculado &agrave; conclus&atilde;o da mentoria &ldquo;Na Rota do Mercado Financeiro&rdquo;.
            </p>
            <br />
            <p>
              <strong>VALOR</strong>: R$ 2.977,00 (dois mil novecentos e setenta e sete reais) &agrave; vista, ou parcelamento via cart&atilde;o de
              cr&eacute;dito, com acr&eacute;scimos legais (conforme operadora, a ser confirmado no ato da contrata&ccedil;&atilde;o pelo
              pr&oacute;prio CONTRATANTE).
            </p>
            <br />
            <p>
              <strong>NATUREZA LEGAL</strong>: Lei n&ordm; 10.406/2002
            </p>
          </TermHeadBox>

          <br />

          <RichContent>
            {`
              <p style="text-align: center;">
                <strong>
                  <u>I - CONSIDERA&Ccedil;&Otilde;ES PRELIMINARES:</u>
                </strong>
              </p>
              <ol>
                <li>
                  Considerando que a empresa CONTRATADA possui <em>know-how</em> na &aacute;rea
                  educacional, oferece ao(&agrave;) CONTRATANTE seu escopo
                  t&eacute;cnico-profissional para o desenvolvimento da mentoria &ldquo;Na Rota do
                  Mercado Financeiro&rdquo;, a ser disponibilizada ao(&agrave;) CONTRATANTE;
                </li>
                <li>
                  A mentoria consiste em um programa de aproximadamente oito semanas, cujo objetivo
                  &eacute; o de trazer clareza sobre as habilidades e compet&ecirc;ncias relevantes
                  para o ingresso e crescimento profissional no mercado financeiro;
                </li>
                <li>
                  Os conte&uacute;dos ser&atilde;o disponibilizados em uma plataforma pr&oacute;pria
                  da CONTRATADA e em grupos de <em>WhatsApp</em>;
                </li>
                <li>
                  Al&eacute;m disso, o programa conta com <em>lives</em> de profissionais de
                  refer&ecirc;ncia no mercado;
                </li>
                <li>
                  A mentoria adquirida &eacute; de uso
                  <strong>
                    <u>pessoal e individual</u>
                  </strong>
                  e tem car&aacute;ter meramente educativo, raz&atilde;o pela qual a CONTRATADA e
                  seus colaboradores n&atilde;o se responsabilizam por qualquer a&ccedil;&atilde;o
                  ou decis&atilde;o executada com base em suas informa&ccedil;&otilde;es e em seu
                  conte&uacute;do.
                </li>
              </ol>
              <p style="text-align: center;">
                <strong>
                  <u>II - CONDI&Ccedil;&Otilde;ES ESPEC&Iacute;FICAS:</u>
                </strong>
              </p>
              <p>
                <strong>Cl&aacute;usula 1&ordf; - Do objeto do contrato e valor:</strong> O objeto
                deste contrato constitui na presta&ccedil;&atilde;o de servi&ccedil;os para
                aplica&ccedil;&atilde;o de conte&uacute;dos sobre o mercado financeiro, a ser
                disponibilizada ao(&agrave;) CONTRATANTE. O referido curso ser&aacute; realizado de
                forma <em>on-line</em>.
              </p>
              <p>
                Par&aacute;grafo &uacute;nico: Ter-se-&aacute;, para devidos fins, o valor inicial
                da mentoria, material e conte&uacute;do o valor de R$ <strong>2977,00</strong> (
                <strong>dois</strong> mil <strong>novecentos e setenta e sete </strong>reais)
              </p>
              <p>
                <strong>Cl&aacute;usula 2&ordf; - Do prazo:</strong> O prazo de vig&ecirc;ncia deste
                instrumento persistir&aacute; pelo per&iacute;odo de dura&ccedil;&atilde;o da
                mentoria, acrescido de 90 (noventa) dias.
              </p>
              <p>
                Par&aacute;grafo &uacute;nico: Vencido o prazo ajustado originalmente, o presente
                neg&oacute;cio jur&iacute;dico n&atilde;o se prorrogar&aacute;
                automaticamente.&nbsp;
              </p>
              <p>
                <strong>Cl&aacute;usula 3&ordf; - Dos servi&ccedil;os contratados:</strong> A
                CONTRATADA, durante o per&iacute;odo de vig&ecirc;ncia do presente instrumento,
                prestar&aacute; os seguintes servi&ccedil;os ao(&agrave;) CONTRATANTE:
              </p>
              <ol type="a">
                <li>
                  Apoio t&eacute;cnico-profissional para o melhor desenvolvimento dos
                  servi&ccedil;os contratados;
                </li>
                <li>
                  Elabora&ccedil;&atilde;o de todo o material e conte&uacute;do da mentoria
                  contratada;
                </li>
                <li>
                  Disponibiliza&ccedil;&atilde;o de todo o material e conte&uacute;do em plataforma
                  pr&oacute;pria da CONTRATADA, assim como em grupos de <em>WhatsApp</em>;
                </li>
                <li>
                  <em>Lives</em> de profissionais de refer&ecirc;ncia no mercado;
                </li>
              </ol>
              <p>
                Par&aacute;grafo &uacute;nico: O acesso ao curso somente ser&aacute; efetivado com o
                correto preenchimento do cadastro da ficha de inscri&ccedil;&atilde;o
                disponibilizada ao(&agrave;) CONTRATANTE na plataforma on-line da CONTRATADA, e
                ainda, ap&oacute;s a confirma&ccedil;&atilde;o do login e senha do usu&aacute;rio
                fornecidos pela CONTRATADA por e-mail.
              </p>
              <p>
                <strong>
                  Cl&aacute;usula 4&ordf; - Das obriga&ccedil;&otilde;es da CONTRATADA:
                </strong>
                Constituem obriga&ccedil;&otilde;es da CONTRATADA para com o(a) CONTRATANTE, visando
                o fiel e integral cumprimento do presente contrato de presta&ccedil;&atilde;o de
                servi&ccedil;os:
              </p>
              <ol type="a">
                <li>Cumprir rigorosamente os servi&ccedil;os descritos neste contrato;</li>
                <li>
                  Manter-se atualizada nas t&eacute;cnicas inerentes &agrave;
                  presta&ccedil;&atilde;o dos servi&ccedil;os objeto do presente;
                </li>
                <li>
                  Zelar para que a qualidade da mentoria seja mantida dentro dos padr&otilde;es de
                  excel&ecirc;ncia nacional e internacional;
                </li>
                <li>
                  Responsabilizar-se, com exclusividade, por todos e eventuais funcion&aacute;rios,
                  colaboradores, mentores, palestrantes, e quaisquer outros profissionais que lhe
                  prestem servi&ccedil;os, em favor do cumprimento da legisla&ccedil;&atilde;o
                  fiscal, previdenci&aacute;ria, securit&aacute;ria e trabalhista vigentes,
                  n&atilde;o havendo, portanto, qualquer v&iacute;nculo empregat&iacute;cio entre os
                  contratantes, bem como para o regular atendimento &agrave;s
                  obriga&ccedil;&otilde;es sociais, civis, tribut&aacute;rias, fiscais e
                  trabalhistas decorrentes da execu&ccedil;&atilde;o deste contrato;
                </li>
                <li>
                  Permitir acesso do(a) CONTRATANTE ao conte&uacute;do e aos materiais
                  disponibilizados na plataforma MELVER (CONTRATADA). O acesso a plataforma
                  educacional ficar&aacute; dispon&iacute;vel por 90 (noventa) dias corridos
                  ap&oacute;s o encerramento do curso;
                </li>
                <li>
                  A CONTRATADA n&atilde;o se responsabiliza por eventuais problemas decorrentes da
                  interrup&ccedil;&atilde;o dos servi&ccedil;os de provedor de acesso &agrave;
                  internet do(a) CONTRATANTE, nem mesmo pela paralisa&ccedil;&atilde;o do
                  fornecimento de energia el&eacute;trica para o funcionamento do sistema de seu
                  provedor de acesso, falhas nos sistemas de transmiss&atilde;o ou de roteamento de
                  acesso &agrave; internet, incompatibilidade dos sistemas dos usu&aacute;rios com
                  os do provedor de acesso, ou qualquer a&ccedil;&atilde;o de terceiros que
                  impe&ccedil;am a presta&ccedil;&atilde;o de servi&ccedil;o resultante de caso
                  fortuito ou de for&ccedil;a maior relacionados no C&oacute;digo Civil Brasileiro;
                </li>
                <li>
                  Emitir o Certificado de Conclus&atilde;o do Curso, ao(&agrave;) aluno(a)
                  (CONTRATANTE) que tenha cumprido 90% (noventa por cento) da
                  programa&ccedil;&atilde;o em at&eacute; 90 (noventa) dias ap&oacute;s encerramento
                  da mentoria.
                </li>
              </ol>
              <p>
                <strong>
                  Cl&aacute;usula 5&ordf; - Das obriga&ccedil;&otilde;es do(a) CONTRATANTE:
                </strong>
                O(A) <strong>CONTRATANTE</strong> desde j&aacute;, reconhece e se obriga a:
              </p>
              <ol type="a">
                <li>
                  Cumprir os requisitos exigidos para realiza&ccedil;&atilde;o da mentoria, quitando
                  o valor correspondente ao presente instrumento nas condi&ccedil;&otilde;es
                  oferecidas pela CONTRATADA;
                </li>
                <li>
                  Responder, no prazo estabelecido pela CONTRATADA, todas as mensagens recebidas;
                </li>
                <li>
                  Enviar os trabalhos, projetos, resumos etc. (caso existam) para
                  avalia&ccedil;&atilde;o, dentro do prazo estabelecido pela CONTRATADA e todos os
                  seus colaboradores;
                </li>
                <li>
                  Manter seus dados cadastrais atualizados e com informa&ccedil;&otilde;es
                  ver&iacute;dicas, bem como zelar pela confidencialidade de sua senha e de seu
                  <em>login</em>, de forma a n&atilde;o permitir seu compartilhamento com terceiros;
                </li>
                <li>Honrar com os compromissos e prazos assumidos no aceite deste contrato;</li>
                <li>N&atilde;o violar a privacidade de outros usu&aacute;rios;</li>
                <li>
                  N&atilde;o utilizar indevidamente c&oacute;digos de acesso <em>login </em>e/ou
                  senha de outros usu&aacute;rios;
                </li>
                <li>
                  N&atilde;o reproduzir, sob qualquer forma os materiais e conte&uacute;dos da
                  mentoria, sob pena de responder civil e criminalmente perante a CONTRATADA e
                  terceiros, nos termos da Lei n&deg; 9.610/68, assim como da Lei n&deg; 9.609/98,
                  por viola&ccedil;&atilde;o dos direitos autorais dos materiais e conte&uacute;dos
                  da mentoria, assim como viola&ccedil;&atilde;o da propriedade intelectual, devendo
                  o uso de todo o conte&uacute;do produzido, ser feito exclusivamente em
                  &acirc;mbito pr&oacute;prio e privado pelo(a) CONTRATANTE;
                </li>
                <li>
                  N&atilde;o ceder a terceiros seu nome de usu&aacute;rio, <em>login</em> e senha,
                  uma vez que ser&aacute; respons&aacute;vel por quaisquer encargos e
                  atribui&ccedil;&otilde;es decorrentes da utiliza&ccedil;&atilde;o dos mesmos,
                  devendo tomar todas as medidas necess&aacute;rias para IMPEDIR a
                  utiliza&ccedil;&atilde;o de todo o material, conte&uacute;do e plataforma MELVER
                  de maneira indevida por estranhos ao presente instrumento. Caso a CONTRATADA venha
                  a tomar conhecimento da permiss&atilde;o ou uso do acesso exclusivo do(a)
                  CONTRATANTE a/por outro indiv&iacute;duo, a CONTRATADA poder&aacute; bloquear o
                  login do(a) CONTRATANTE, sendo tomadas as provid&ecirc;ncias legais
                  cab&iacute;veis;
                </li>
                <li>
                  N&atilde;o propagar v&iacute;rus de computador e programas invasivos ou outras
                  formas de programas computacionais, autorreplicantes ou n&atilde;o, que
                  prejudiquem a opera&ccedil;&atilde;o das redes e de computadores individuais;
                </li>
                <li>
                  N&atilde;o tentar burlar o sistema de seguran&ccedil;a de computadores para os
                  quais n&atilde;o possua autoriza&ccedil;&atilde;o de acesso, assim como n&atilde;o
                  corromper ou destruir dados, arquivos ou programas;
                </li>
                <li>
                  N&atilde;o plagiar, piraterar, muito menos comercializar, no todo ou em parte,
                  qualquer conte&uacute;do e material oferecidos na mentoria;
                </li>
                <li>
                  O(A) CONTRATANTE autoriza que seu nome completo e n&uacute;mero do CPF sejam
                  lan&ccedil;ados em todas as p&aacute;ginas das apostilas fornecidas pela
                  CONTRATADA, como tamb&eacute;m em marca d&rsquo;&aacute;gua em todas as videoaulas
                  produzidas pela CONTRATADA, garantindo, assim, a exclusividade de todo o material
                  e conte&uacute;do produzidos para a utiliza&ccedil;&atilde;o pessoal e
                  individualizada do(a) CONTRATANTE, n&atilde;o configurando, assim, qualquer
                  viola&ccedil;&atilde;o da CONTRATADA &agrave; LGPD;
                </li>
                <li>
                  Por fim, n&atilde;o veicular mensagens que possam vir a ser consideradas ofensivas
                  e subversivas ou que firam princ&iacute;pios &eacute;ticos.
                </li>
              </ol>
              <p style="text-align: center;">
                <strong>
                  <u>III - CONDI&Ccedil;&Otilde;ES GERAIS:</u>
                </strong>
              </p>
              <p>
                <strong>Cl&aacute;usula 6&ordf; - Do idioma/legisla&ccedil;&atilde;o:</strong> As
                partes contratantes, desde j&aacute;, ajustam para todos os fins de direito que o
                presente instrumento, bem como os eventuais anexos, aditivos e aditamentos,
                ser&atilde;o elaborados em l&iacute;ngua portuguesa (portugu&ecirc;s/Brasil),
                renunciando-se outros idiomas, e ser&atilde;o regidos pela legisla&ccedil;&atilde;o
                existente no territ&oacute;rio nacional, em especial a Lei n&ordm; 10.406/02.
              </p>
              <p>
                <strong>
                  Cl&aacute;usula 7&ordf; - Da Vig&ecirc;ncia, efic&aacute;cia e cess&atilde;o dos
                  direitos e obriga&ccedil;&otilde;es decorrentes do presente instrumento:
                </strong>
                O neg&oacute;cio jur&iacute;dico passar&aacute; a vigorar entre as partes a partir
                da assinatura digital (aceite) deste, sendo certo que, quaisquer
                altera&ccedil;&otilde;es, emendas ou aditamentos a este instrumento, somente
                produzir&atilde;o efeitos se forem realizados por escrito e assinados pelas partes
                contratantes.
              </p>
              <p>
                Par&aacute;grafo &uacute;nico: Os direitos e as obriga&ccedil;&otilde;es decorrentes
                deste instrumento n&atilde;o poder&atilde;o ser cedidos ou sub-rogados a terceiros
                estranhos ao pacto sem anu&ecirc;ncia escrita das partes. O descumprimento do aqui
                ajustado implicar&aacute; em infra&ccedil;&atilde;o contratual grave, resultando na
                imediata rescis&atilde;o do neg&oacute;cio jur&iacute;dico, sob pena das medidas
                judiciais cab&iacute;veis.
              </p>
              <p>
                <strong>Cl&aacute;usula 8&ordf; - Do car&aacute;ter de exclusividade:</strong> O
                presente instrumento &eacute; firmado em car&aacute;ter de exclusividade, n&atilde;o
                podendo o(a) CONTRATANTE utilizar todo e qualquer conte&uacute;do desenvolvido pela
                CONTRATADA para qualquer outra pessoa, f&iacute;sica ou jur&iacute;dica.
              </p>
              <p>
                <strong>Cl&aacute;usula 9&ordf; - Princ&iacute;pios corporativos:</strong> A
                CONTRATADA, desde j&aacute;, compromete-se a respeitar e aplicar toda a
                legisla&ccedil;&atilde;o e/ou regulamenta&ccedil;&atilde;o federal, estadual e/ou
                municipal aplic&aacute;veis para a execu&ccedil;&atilde;o do presente instrumento,
                em especial as legisla&ccedil;&otilde;es referentes ao meio ambiente, diretos
                trabalhistas e previdenci&aacute;rios, bem como os princ&iacute;pios e as
                pol&iacute;ticas a seguir descritos:
              </p>
              <ol type="a">
                <li>
                  N&atilde;o empregar ou contratar para o trabalho crian&ccedil;as e/ou menores em
                  desacordo com a legisla&ccedil;&atilde;o trabalhista vigente, em qualquer
                  atividade relacionada com o objeto do presente contrato;
                </li>
                <li>
                  Providenciar aos seus empregados, prepostos e demais pessoas credenciadas um
                  ambiente seguro de trabalho;
                </li>
                <li>
                  Tratar todos os empregados, prepostos e demais pessoas credenciadas com respeito e
                  dignidade e n&atilde;o tolerar que eles sejam v&iacute;timas de qualquer forma de
                  discrimina&ccedil;&atilde;o ou ass&eacute;dio (seja sexual ou moral);
                </li>
                <li>
                  N&atilde;o tolerar qualquer tipo de discrimina&ccedil;&atilde;o ou ass&eacute;dio
                  por parte de seus empregados;
                </li>
                <li>
                  N&atilde;o se envolver em qualquer tipo de a&ccedil;&atilde;o abusiva contra os
                  direitos humanos;
                </li>
                <li>
                  N&atilde;o empregar ou contratar empresas que utilizem o trabalho for&ccedil;ado
                  ou escravo em qualquer atividade relacionada com a presta&ccedil;&atilde;o de
                  servi&ccedil;os para a contratada;
                </li>
                <li>
                  N&atilde;o tolerar qualquer forma de corrup&ccedil;&atilde;o, inclusive,
                  extors&atilde;o e suborno;
                </li>
                <li>
                  Garantir que suas a&ccedil;&otilde;es n&atilde;o desrespeitem o meio ambiente.
                </li>
              </ol>
              <p style="text-align: center;">
                <strong>
                  <u>IV &ndash; PROTE&Ccedil;&Atilde;O E PRIVACIDADE DOS DADOS PESSOAIS</u>
                </strong>
              </p>
              <p>
                <strong>Cl&aacute;usula 10&ordf;</strong>
                <strong>- Da prote&ccedil;&atilde;o de dados pessoais: </strong>A CONTRATADA
                atender&aacute; &agrave;s exig&ecirc;ncias da Lei Geral de Prote&ccedil;&atilde;o de
                Dados Pessoais (LGPD) &ndash; Lei n&ordm; 13709/2008.
              </p>
              <p>
                Par&aacute;grafo &uacute;nico: A CONTRATADA monitorar&aacute;, por meios adequados,
                sua pr&oacute;pria conformidade e a de seus funcion&aacute;rios e suboperadores com
                as respectivas obriga&ccedil;&otilde;es de prote&ccedil;&atilde;o de dados, caso
                aplic&aacute;vel.
              </p>
              <p>
                <strong>Cl&aacute;usula 11&ordf; - Responsabilidade dos Dados</strong>: O(A)
                CONTRATANTE se responsabilizar&aacute; pelos dados que inserir na plataforma ou
                eventualmente compartilhados com a CONTRATADA.
              </p>
              <p>
                Par&aacute;grafo primeiro: A CONTRATADA se compromete a tratar como confidencial
                todos os dados a que vier a ter acesso em raz&atilde;o do cumprimento das
                disposi&ccedil;&otilde;es deste contrato.
              </p>
              <p>
                Par&aacute;grafo segundo: &nbsp;A CONTRATADA tratar&aacute; os dados com o
                n&iacute;vel de seguran&ccedil;a exigido pela legisla&ccedil;&atilde;o vigente.
              </p>
              <p>
                Par&aacute;grafo terceiro:&nbsp; O(A) CONTRATANTE autoriza o lan&ccedil;amento de
                seu nome e CPF em todo e qualquer material e conte&uacute;do produzidos pela
                CONTRATADA (impresso, eletr&ocirc;nico, videoaulas etc.).
              </p>
              <p>
                <strong>Cl&aacute;usula 12&ordf; - Do armazenamento de Dados:</strong> Os dados
                coletados ser&atilde;o armazenados em ambiente seguro e controlado da CONTRATADA, ou
                de terceiro (pessoa f&iacute;sica ou jur&iacute;dica) por ela contratado.
              </p>
              <p>
                <strong>Cl&aacute;usula 13&ordf; - Da Legalidade dos Dados:</strong> A CONTRATADA
                n&atilde;o se obrigar&aacute; a processar, tratar ou armazenar quaisquer dados do(a)
                CONTRATANTE se houver raz&otilde;es para crer que tal processamento, tratamento ou
                armazenamento possa imputar &agrave; CONTRATADA infra&ccedil;&atilde;o de qualquer
                lei aplic&aacute;vel.
              </p>
              <p>
                <strong>
                  Cl&aacute;usula 14&ordf; - Da Seguran&ccedil;a da informa&ccedil;&atilde;o:
                </strong>
                A CONTRATADA prestar&aacute; os servi&ccedil;os mediante esfor&ccedil;o
                razo&aacute;vel em conformidade com controles de seguran&ccedil;a da
                informa&ccedil;&atilde;o e com a legisla&ccedil;&atilde;o aplic&aacute;vel.
              </p>
              <p>
                <strong>Cl&aacute;usula 15&ordf; - Do uso indevido:</strong> Caso a CONTRATADA, a
                seu crit&eacute;rio, constate que a plataforma contratada seja utilizada para
                quaisquer fins ilegais, il&iacute;citos, que afrontem a legisla&ccedil;&atilde;o de
                prote&ccedil;&atilde;o de dados pessoais ou contr&aacute;rios &agrave; moralidade
                pelo(a) CONTRATANTE, a CONTRATADA comunicar&aacute; o(a) CONTRATANTE para que cesse
                o uso da plataforma contratada para tal fim no prazo de cura estabelecido neste
                contrato, sujeito as mesmas consequ&ecirc;ncias tamb&eacute;m estabelecidas em caso
                de descumprimento.
              </p>
              <p style="text-align: center;">
                <strong>
                  <u>V - DESIST&Ecirc;NCIAS, CANCELAMENTOS E REEMBOLSOS</u>
                </strong>
              </p>
              <p>
                <strong>Cl&aacute;usula 16&ordf; - Da desist&ecirc;ncia: </strong>Nos termos do art.
                49 do C&oacute;digo de Defesa do Consumidor, o(a) CONTRATANTE poder&aacute;, no
                prazo de 7 (sete) dias contados da libera&ccedil;&atilde;o da primeira aula, exercer
                o direito de arrependimento, sendo restitu&iacute;do integralmente o valor pago.
              </p>
              <p>
                Par&aacute;grafo primeiro: Decorrido o prazo descrito nesta cl&aacute;usula,
                n&atilde;o caber&aacute; restitui&ccedil;&atilde;o em caso de desist&ecirc;ncia
                do(a) CONTRATANTE.
              </p>
              <p>
                Par&aacute;grafo segundo: Para solicitar o cancelamento, o(a) aluno(a) CONTRATANTE
                dever&aacute; formalizar a expressa op&ccedil;&atilde;o
                (desist&ecirc;ncia/cancelamento), mediante envio de e-mail para:
                <a href="mailto:financeiro@melver.com.br">financeiro@melver.com.br</a>. O valor pago
                ser&aacute; integralmente devolvido em at&eacute; 60 (sessenta) dias ap&oacute;s a
                confirma&ccedil;&atilde;o do recebimento do pedido de cancelamento pela CONTRATADA.
              </p>
              <p>
                Par&aacute;grafo terceiro: Al&eacute;m da possibilidade de reembolso previsto acima,
                o(a) CONTRATANTE tamb&eacute;m ter&aacute; direito &agrave;
                restitui&ccedil;&atilde;o dos valores pagos em caso de erros ou problemas
                t&eacute;cnicos comprovados, que impossibilitem o acesso aos cursos contratados.
              </p>
              <p>
                Par&aacute;grafo quarto: Ap&oacute;s a emiss&atilde;o do certificado, n&atilde;o
                ser&aacute; concedido o cancelamento e o reembolso de quaisquer valores em
                hip&oacute;tese alguma.
              </p>
              <p>
                Par&aacute;grafo quinto: Em caso de pagamento por boleto banc&aacute;rio, o
                reembolso ser&aacute; efetuado somente&nbsp;na conta banc&aacute;ria do
                usu&aacute;rio (vinculado ao CPF) que realizou a compra.
              </p>
              <p>
                Par&aacute;grafo sexto: Demais hip&oacute;teses n&atilde;o previstas neste
                instrumento, ensejam o contato direto com a equipe da CONTRATADA, para
                averigua&ccedil;&atilde;o de alternativas visando a satisfa&ccedil;&atilde;o de
                ambas as partes contratantes.
              </p>
              <p style="text-align: center;">
                <strong>
                  <u>VI &ndash; NOTAS FISCAIS</u>
                </strong>
              </p>
              <p>
                <strong>Cl&aacute;usula 17&ordf; - Da emiss&atilde;o de notas fiscais:</strong> Em
                raz&atilde;o da particularidade da mentoria contratada, considerando que a
                CONTRATADA ser&aacute; a respons&aacute;vel pela produ&ccedil;&atilde;o,
                confec&ccedil;&atilde;o, edi&ccedil;&atilde;o, formata&ccedil;&atilde;o e
                disponibiliza&ccedil;&atilde;o de todo o material e conte&uacute;do fornecidos
                ao(&agrave;) CONTRATANTE, do montante global ajustado na cl&aacute;usula 1&ordf;,
                par&aacute;grafo &uacute;nico, 75% (setenta e cinco por cento) se referem &agrave;
                presta&ccedil;&atilde;o de servi&ccedil;os tipificada pelo CNAE 58.11-5-00, com a
                emiss&atilde;o de Nota Fiscal Eletr&ocirc;nica proporcional &agrave; quantia.
              </p>
              <p>
                Par&aacute;grafo &uacute;nico: Em outro giro, 25% (vinte e cinco por cento) do
                montante global ajustado na cl&aacute;usula 1&ordf;, par&aacute;grafo &uacute;nico,
                se referem aos servi&ccedil;os indicados no CNAE 85.99-6-04, com a emiss&atilde;o de
                Nota Fiscal Eletr&ocirc;nica igualmente proporcional &agrave; quantia.
              </p>
              <p style="text-align: center;">
                <strong>
                  <u>VII &ndash; EFIC&Aacute;CIA DO CONTRATO ELETR&Ocirc;NICO</u>
                </strong>
              </p>
              <p>
                <strong>
                  Cl&aacute;usula 18&ordf; - Da efic&aacute;cia eletr&ocirc;nica do presente
                  instrumento:
                </strong>
                As partes contratantes reconhecem a veracidade, autenticidade, integridade, validade
                e efic&aacute;cia deste contrato e seus termos, nos moldes do art. 219 do
                C&oacute;digo Civil/02, em formato eletr&ocirc;nico e/ou assinado pelos contratantes
                (CONTRATADA e CONTRATANTE) digitalmente.
              </p>
              <p>
                Par&aacute;grafo &uacute;nico: Por se tratar de aceita&ccedil;&atilde;o
                eletr&ocirc;nica, que se far&aacute; mediante o &ldquo;clique do bot&atilde;o
                ACEITO&rdquo; pelo(a) CONTRATANTE, este declara total aceite aos termos ajustados,
                reconhecendo que leu e est&aacute; ciente e de pleno acordo com todos os termos e
                com todas as condi&ccedil;&otilde;es deste contrato.
              </p>
              <p style="text-align: center;">
                <strong>
                  <u>VIII - FORO</u>
                </strong>
              </p>
              <p>
                <strong>Cl&aacute;usula 19&ordf; - Do Foro:</strong> Fica eleito o foro central da
                comarca de Florian&oacute;polis/Capital, com ren&uacute;ncia de qualquer outro, por
                mais privilegiado que seja, para dirimir quaisquer diverg&ecirc;ncias oriundas
                deste.
              </p>
            </>`}
          </RichContent>

          <Flex mt={30} mb={15} alignItems="center">
            <input
              type="checkbox"
              onChange={(e) => {
                setOptin(e.target.checked);
              }}
              checked={optin}
              name="optin"
              id="optin"
            />

            <Typography type="type2">
              <label htmlFor="optin">Declaro que li e aceito o Termo de Adesão para Mentoria Na Rota do Mercado Financeiro</label>
            </Typography>
          </Flex>

          <Button onClick={closeTerm} mt={30}>
            Fechar
          </Button>
        </Content>
      </Wrapper>
      <NoScroll />
    </>
  );
};
export default Term2;
